import React, { useState } from 'react'
import { Button } from 'reactstrap'
import oikosApi from '../../../services/oikos'
import { notifyError, notifySuccess } from '../../../utils/notify'
import ModalConfirmacao from '../ModalConfirmacao/ModalConfirmacao'
import AddFilesNoForm from '../../Template/Files/AddFilesNoForm'
import { resolveBdroDtVencFromEvento } from '../ModalFormContrForn/contrFornEntregaveisUtils'
import {
  TP_DOCUMENTO_NF,
  TP_DOCUMENTO_COBRANCA,
  anexarArquivoComoDocumento,
} from '../ModalFormContrForn/contrFornNfDocumentos'
import { classificarDocumentoCobrancaOuNf } from '../../../utils/classificarDocumentoCobrancaOuNf'

const CONTRATOS_ANEXO_SEM_EVIDENCIA = [
  { cnpj: '43694604000198', nome: 'inhire' },
  { cnpj: '50724497000169', nome: 'nibsaas' },
]

const TIPO_LABEL = {
  nf: 'nota fiscal',
  cobranca: 'documento de cobrança',
}

export const isContratoInhire = ({ contrForn = {}, fornecedor = {} } = {}) => {
  const cnpj = String(fornecedor.pj_cnpj || contrForn.pj_cnpj || '').replace(/\D/g, '')
  const texto = [
    fornecedor.pj_nomefanta,
    fornecedor.pj_razaosocial,
    contrForn.contrForn_desc,
    contrForn.contratado_nomePj,
  ].join(' ').toLowerCase()
  return CONTRATOS_ANEXO_SEM_EVIDENCIA.some((item) => (
    cnpj === item.cnpj || texto.includes(item.nome)
  ))
}

const outroTipo = (tipo) => (tipo === 'nf' ? 'cobranca' : 'nf')

const nomeArquivo = (file) => file?.data?.name || file?.data?.path || file?.props?.name || 'arquivo'

export const ButtonAnexarBorderoInhire = (props) => {
  const [open, setOpen] = useState(false)
  const [loading, setLoading] = useState(false)
  const [lendo, setLendo] = useState(false)
  const [primeiro, setPrimeiro] = useState(null)
  const [segundo, setSegundo] = useState(null)
  const [dispensado, setDispensado] = useState(false)

  const ehCartao = Number(props.contrFornEventoData?.meioPgto_id) === 6
  const jaNoBordero = Boolean(Number(props.contrFornEventoData?.bdro_id))

  const reset = () => {
    setPrimeiro(null)
    setSegundo(null)
    setDispensado(false)
    setLendo(false)
  }

  const fechar = () => {
    if (loading) return
    setOpen(false)
    reset()
  }

  const classificarAnexo = async (lista) => {
    const file = lista?.[0]
    if (!file) return null
    setLendo(true)
    try {
      return await classificarDocumentoCobrancaOuNf(file)
    } catch (error) {
      console.error(error)
      return null
    } finally {
      setLendo(false)
    }
  }

  const aoAnexarPrimeiro = async (lista) => {
    if (!lista?.length) {
      setPrimeiro(null)
      setSegundo(null)
      setDispensado(false)
      return
    }
    const file = lista[0]
    const tipo = await classificarAnexo(lista)
    setPrimeiro({ file, tipo })
    setSegundo(null)
    setDispensado(false)
  }

  const aoAnexarSegundo = async (lista) => {
    if (!lista?.length) {
      setSegundo(null)
      return
    }
    const file = lista[0]
    const tipo = await classificarAnexo(lista)
    if (tipo && primeiro?.tipo && tipo === primeiro.tipo) {
      notifyError(`Este arquivo também é ${TIPO_LABEL[tipo]}. Anexe o outro documento ou dispense.`)
      setSegundo(null)
      return
    }
    setSegundo({ file, tipo })
    setDispensado(false)
  }

  const escolherTipo = (tipo) => {
    setPrimeiro((atual) => (atual ? { ...atual, tipo } : atual))
  }

  const cadastrar = async () => {
    if (!primeiro?.tipo) {
      notifyError('Anexe um arquivo e indique se é nota fiscal ou documento de cobrança.')
      return
    }
    if (!segundo && !dispensado) {
      notifyError(`Anexe ${TIPO_LABEL[outroTipo(primeiro.tipo)]} ou dispense esse documento.`)
      return
    }

    const evento = props.contrFornEventoData
    const contrato = props.contrFornData
    setLoading(true)
    try {
      const bdroCreated = await oikosApi.post('/', {
        action: 'insert',
        table: 'bdro',
        data: {
          bdro_vlr: evento.contrFornEvento_vlr || 0,
          bdro_dtVenc: resolveBdroDtVencFromEvento(evento),
          bdro_desc: evento.contrFornEvento_desc || undefined,
          bdro_favTab: contrato.contrForn_parteTab || undefined,
          bdro_favId: contrato.contrForn_parteId || undefined,
          orcItem_id: contrato.orcItem_id || undefined,
          bdro_tabRef: 'contrFornEvento',
          bdro_tabId: evento.contrFornEvento_id || undefined,
          ...(ehCartao ? { meioPgto_id: 6 } : {}),
        },
      })
      const bdroId = Number(bdroCreated?.data?.[0]?.bdro_id) || 0
      if (!bdroId) throw new Error('O borderô não retornou o id.')

      const anexos = [
        { file: primeiro.file, tipo: primeiro.tipo },
        ...(segundo ? [{ file: segundo.file, tipo: segundo.tipo || outroTipo(primeiro.tipo) }] : []),
      ]
      for (let i = 0; i < anexos.length; i += 1) {
        const item = anexos[i]
        const ehNf = item.tipo === 'nf'
        await anexarArquivoComoDocumento(item.file, {
          tpDocumentoId: ehNf ? TP_DOCUMENTO_NF : TP_DOCUMENTO_COBRANCA,
          documentoDesc: `${ehNf ? 'Nota fiscal' : 'Documento de cobrança'} ${evento.contrFornEvento_desc || ''} ${contrato.contrForn_desc || ''}`.trim(),
          eventoId: evento.contrFornEvento_id,
          bdroId,
        })
      }

      await oikosApi.post('/', {
        action: 'update',
        table: 'contrFornEvento',
        data: {
          contrFornEvento_id: evento.contrFornEvento_id,
          bdro_id: bdroId,
          ...(ehCartao ? { contrFornEvento_aprovLiberado: 1 } : {}),
        },
      })

      if (typeof props.getEventos === 'function') {
        await props.getEventos({ includeArquivos: true })
      }
      if (typeof props.updateOneEvento === 'function') {
        await props.updateOneEvento(evento.contrFornEvento_id, String(contrato.contrForn_id))
      }

      notifySuccess(ehCartao
        ? 'Parcela de cartão cadastrada no borderô. Ela fica oculta até alguém escolher exibir.'
        : 'Parcela cadastrada no borderô.')
      setOpen(false)
      reset()
    } catch (error) {
      console.error(error)
      notifyError(ehCartao
        ? 'Não foi possível registrar os documentos da mensalidade.'
        : 'Não foi possível cadastrar a parcela no borderô.')
    } finally {
      setLoading(false)
    }
  }

  if (jaNoBordero) {
    return <span className="text-success">No borderô</span>
  }

  const falta = primeiro?.tipo ? outroTipo(primeiro.tipo) : null

  let texto = 'Anexe o documento de cobrança ou a nota fiscal.'
  if (lendo) texto = 'Lendo o arquivo para identificar o tipo.'
  else if (primeiro && !primeiro.tipo) texto = 'Não foi possível identificar se este arquivo é nota fiscal ou documento de cobrança.'
  else if (primeiro?.tipo && !segundo && !dispensado) {
    texto = `Identificamos este arquivo como ${TIPO_LABEL[primeiro.tipo]}. Anexe ${TIPO_LABEL[falta]}, ou dispense esse documento.`
  } else if (dispensado) {
    texto = `${TIPO_LABEL[falta]} dispensado. A parcela segue só com ${TIPO_LABEL[primeiro.tipo]}.`
  } else if (segundo) {
    texto = 'Os dois documentos estão anexados.'
  }

  return (
    <>
      <Button onClick={() => setOpen(true)} disabled={loading}>Anexar</Button>
      <ModalConfirmacao
        openModal={open}
        isLoading={loading || lendo}
        onConfirm={cadastrar}
        title="Anexar e cadastrar no borderô"
        text={texto}
        onClosed={fechar}
        confirmButtonText="Cadastrar no borderô"
        secondaryButtonText={falta && !segundo && !dispensado ? `Dispensar ${TIPO_LABEL[falta]}` : undefined}
        onSecondary={falta && !segundo && !dispensado ? () => setDispensado(true) : undefined}
        childComponent={(
          <div>
            <span className="font-weight-bold">Documento</span>
            <AddFilesNoForm
              multiple={false}
              files={primeiro ? [primeiro.file] : []}
              onFilesChange={aoAnexarPrimeiro}
            />
            {primeiro && !primeiro.tipo && !lendo && (
              <div className="d-flex mb-2">
                <Button size="sm" className="mr-2" onClick={() => escolherTipo('nf')}>É nota fiscal</Button>
                <Button size="sm" onClick={() => escolherTipo('cobranca')}>É documento de cobrança</Button>
              </div>
            )}
            {primeiro?.tipo && !dispensado && (
              <>
                <span className="font-weight-bold">{`Anexar ${TIPO_LABEL[falta]}`}</span>
                <AddFilesNoForm
                  multiple={false}
                  files={segundo ? [segundo.file] : []}
                  onFilesChange={aoAnexarSegundo}
                />
              </>
            )}
            {primeiro?.file && (
              <div className="text-muted" style={{ fontSize: 12 }}>
                {`${nomeArquivo(primeiro.file)}${primeiro.tipo ? ` — ${TIPO_LABEL[primeiro.tipo]}` : ''}`}
                {segundo ? ` · ${nomeArquivo(segundo.file)}` : ''}
              </div>
            )}
          </div>
        )}
      />
    </>
  )
}
